import { api } from "@/lib/api/client"
import type { BaseResponse } from "@/types/api"

import type {
  MillFloorLoad,
  MillFloorLoadFilter,
  MillFloorQueueLot,
  MillFloorUsinage,
  UsinageBucket,
} from "./types"

const BASE = "/exporter/mill-floor"

export async function listMillFloorLoads(
  status: MillFloorLoadFilter = "all",
): Promise<MillFloorLoad[]> {
  const { data } = await api.get<BaseResponse<MillFloorLoad[]>>(
    `${BASE}/loads`,
    { params: { status } },
  )
  if (!data.success) {
    throw new Error(data.message ?? "Could not load mill-floor loads")
  }
  return data.result ?? []
}

// Queue de Lot feed — virtual loads the operator can re-couple.
// Filter values match listMillFloorLoads.
export async function listMillFloorQueueLots(
  status: MillFloorLoadFilter = "all",
): Promise<MillFloorQueueLot[]> {
  const { data } = await api.get<BaseResponse<MillFloorQueueLot[]>>(
    `${BASE}/queue-de-lots`,
    { params: { status } },
  )
  if (!data.success) {
    throw new Error(data.message ?? "Could not load mill-floor queue de lots")
  }
  return data.result ?? []
}

export async function listMillFloorUsinages(
  bucket: UsinageBucket,
): Promise<MillFloorUsinage[]> {
  const { data } = await api.get<BaseResponse<MillFloorUsinage[]>>(
    `${BASE}/usinages`,
    { params: { bucket } },
  )
  if (!data.success) {
    throw new Error(data.message ?? "Could not load usinages")
  }
  return data.result ?? []
}
